import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import Login from "./Components/Login";
import ProtectedRoute from "./Components/ProtectedRoute";
import {ChatContextProvider} from "./context/chatContext";
import HomePage from "./Pages/HomePage";
import Signup from "./Components/Signup";
import ParentDashboard from "./Pages/parent-dashboard/ParentDashboard";
import {AuthBootstrap} from "./authClient";

// Learner Pages
import LearnerProfile from "./Pages/Learner/LearnerProfile";
import LearnerAttendance from "./Pages/Learner/LearnerAttendance";
import LearnerDailyLearnings from "./Pages/Learner/LearnerDailyLearnings";
import LearnerDomains from "./Pages/Learner/LearnerDomains";
import LearnerCompetencies from "./Pages/Learner/LearnerCompetencies";
import LearnerHolisticProgress from "./Pages/Learner/LearnerHolisticProgress";
import LearnerClasses from "./Pages/Learner/LearnerClasses";
import LearnerTeachers from "./Pages/Learner/LearnerTeachers";
import LearnerActivities from "./Pages/Learner/LearnerActivities";

// Other Pages
import AssessmentResults from "./Pages/AssessmentResults";
import ParentProfile from "./Pages/ParentProfile";
import PersonalisedLearning from "./Pages/PersonalisedLearning";
import OfficialReports from "./Pages/OfficialReports";
import OfficialAcademicTranscripts from "./Pages/OfficialAcademicTranscripts";

function App() {
    return (
        <ChatContextProvider>
            <AuthBootstrap>
                <Router>
                    <Routes>
                        <Route path="/" element={<Login panelType="parent" redirectPath="/HomePage"/>}/>

                        <Route path="/Signup" element={<Signup/>}/>

                        <Route path="/HomePage" element={
                            <ProtectedRoute requiredRole="parent">
                                <HomePage/>
                            </ProtectedRoute>
                        }/>

                        <Route path="/ParentDashboard" element={
                            <ProtectedRoute requiredRole="parent">
                                <ParentDashboard/>
                            </ProtectedRoute>
                        }/>

                        {/* Learner Pages */}
                        <Route path="/learner-profile" element={
                            <ProtectedRoute requiredRole="parent">
                                <LearnerProfile/>
                            </ProtectedRoute>
                        }/>

                        <Route path="/learner-attendance" element={
                            <ProtectedRoute requiredRole="parent">
                                <LearnerAttendance/>
                            </ProtectedRoute>
                        }/>

                        <Route path="/learner-daily-learnings" element={
                            <ProtectedRoute requiredRole="parent">
                                <LearnerDailyLearnings/>
                            </ProtectedRoute>
                        }/>

                        <Route path="/learner-domains" element={
                            <ProtectedRoute requiredRole="parent">
                                <LearnerDomains/>
                            </ProtectedRoute>
                        }/>

                        <Route path="/learner-competencies" element={
                            <ProtectedRoute requiredRole="parent">
                                <LearnerCompetencies/>
                            </ProtectedRoute>
                        }/>

                        <Route path="/learner-holistic-progress" element={
                            <ProtectedRoute requiredRole="parent">
                                <LearnerHolisticProgress/>
                            </ProtectedRoute>
                        }/>

                        <Route path="/learner-classes" element={
                            <ProtectedRoute requiredRole="parent">
                                <LearnerClasses/>
                            </ProtectedRoute>
                        }/>

                        <Route path="/learner-teachers" element={
                            <ProtectedRoute requiredRole="parent">
                                <LearnerTeachers/>
                            </ProtectedRoute>
                        }/>

                        <Route path="/learner-activities" element={
                            <ProtectedRoute requiredRole="parent">
                                <LearnerActivities/>
                            </ProtectedRoute>
                        }/>

                        <Route path="/partnership-tracker" element={
                            <ProtectedRoute requiredRole="parent">
                                <HomePage/>
                            </ProtectedRoute>
                        }/>

                        <Route path="/assessment-results" element={
                            <ProtectedRoute requiredRole="parent">
                                <AssessmentResults/>
                            </ProtectedRoute>
                        }/>

                        <Route path="/personalised-learning" element={
                            <ProtectedRoute requiredRole="parent">
                                <PersonalisedLearning/>
                            </ProtectedRoute>
                        }/>

                        <Route path="/parent-profile" element={
                            <ProtectedRoute requiredRole="parent">
                                <ParentProfile/>
                            </ProtectedRoute>
                        }/>
                        <Route path="/official-reports" element={
                            <ProtectedRoute requiredRole="parent">
                                <OfficialReports/>
                            </ProtectedRoute>
                        }/>
                        <Route path="/academic-transcripts" element={
                            <ProtectedRoute requiredRole="parent">
                                <OfficialAcademicTranscripts/>
                            </ProtectedRoute>
                        }/>
                    </Routes>
                </Router>
            </AuthBootstrap>
        </ChatContextProvider>
    );
}

export default App;
